import React from 'react';
import RenderError from './RenderError';
import { disableButtonByStatus } from '../../../helpers';

function Submit({
  handleSubmit,
  text,
  loading,
  disabled = false,
  errors,
  classes = [],
  btnClasses = []
}) {
  const status = wlFipApplicationData.applicationData && wlFipApplicationData.applicationData.status;
  
  return (
    <div className={`grid ${classes.join(' ')}`}>
      <div className="grid__col-xs-8">
        <div className={`${btnClasses.join(' ')} form__field form__field--required`}>
          <div className="form__submit">
            <button
              className={`btn btn--block btn--primary ${
                loading && ' btn--loading'
              }`}
              type="submit"
              name="submit"
              onClick={handleSubmit}
              disabled={disabled === true ? disabled : status && disableButtonByStatus(status)}
            >
              <span className="btn__content">
                <span className="btn__text">{text}</span>
              </span>
            </button>
          </div>
          {errors.form && <RenderError error={errors.form} />}
        </div>
      </div>
    </div>
  );
}

export default Submit;
